module.exports = "/assets/data/6f77baa4d37e54eaaed7d0b05bcaedd6-BL2.data.json";